import { render, staticRenderFns } from "./EditJob.vue?vue&type=template&id=2887a685&scoped=true&"
import script from "./EditJob.vue?vue&type=script&lang=js&"
export * from "./EditJob.vue?vue&type=script&lang=js&"
import style0 from "./EditJob.vue?vue&type=style&index=0&id=2887a685&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2887a685",
  null
  
)

export default component.exports